import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Add as OpenIcon, Remove as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Section, SectionTitle } from './primitives';
import { landing } from './tokens';

interface FaqItem {
  question: string;
  answer: string;
}

const LandingFaq: React.FC = () => {
  const { t } = useTranslation('landing');
  const items = t('faq.items', { returnObjects: true }) as unknown as FaqItem[];
  const [open, setOpen] = useState<number | null>(0);

  return (
    <Section id='perguntas'>
      <Box
        sx={{
          maxWidth: 860,
          mx: 'auto',
          px: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
        }}
      >
        <SectionTitle>{t('faq.title')}</SectionTitle>
        <Box sx={{ borderTop: `1px solid ${landing.line}` }}>
          {items.map((item, index) => {
            const isOpen = open === index;
            const answerId = `faq-answer-${index}`;
            return (
              <Box key={item.question} sx={{ borderBottom: `1px solid ${landing.line}` }}>
                <Box component='h3' sx={{ m: 0, fontFamily: 'inherit' }}>
                  <Box
                    component='button'
                    type='button'
                    aria-expanded={isOpen}
                    aria-controls={answerId}
                    onClick={() => setOpen(isOpen ? null : index)}
                    sx={{
                      width: '100%',
                      minHeight: 68,
                      py: 2.25,
                      px: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 2,
                      bgcolor: 'transparent',
                      border: 0,
                      font: 'inherit',
                      fontSize: 19,
                      fontWeight: 600,
                      color: landing.ink,
                      textAlign: 'left',
                      cursor: 'pointer',
                      '& svg': { color: landing.accent, flexShrink: 0 },
                    }}
                  >
                    {item.question}
                    {isOpen ? <CloseIcon aria-hidden='true' /> : <OpenIcon aria-hidden='true' />}
                  </Box>
                </Box>
                <Box
                  id={answerId}
                  component='p'
                  hidden={!isOpen}
                  sx={{
                    pb: 2.75,
                    color: landing.ink2,
                    fontSize: 17,
                    lineHeight: 1.6,
                    maxWidth: 680,
                  }}
                >
                  {item.answer}
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Section>
  );
};

export default LandingFaq;
